<template>
  <div>
    <v-dialog v-model="dialog.status" 
      persistent
      width="500">
      <v-card class="border-radius box-shadow">
        <v-card-text class="text-second pa-5 pb-0">
          Apakah anda yakin mengubah status <b>{{ detail.title }}</b> ?
        </v-card-text>
        <v-divider class="my-3"/>
        <v-card-text>
          <ValidationObserver ref="observer">
            <ValidationProvider name="Nilai KPR" rules="required" v-slot="{ errors }" v-if="detail.title === 'SP3K'">
              <v-currency-field 
                dense
                outlined
                label="Nilai KPR"
                :color="style.primary"
                prepend-inner-icon="mdi-cash-100"
                v-model="form.nominal"
                :error-messages="errors"
                require>
              </v-currency-field>
            </ValidationProvider>
            <v-menu
              ref="confirm"
              min-width="290px"
              max-width="290px"
              transition="scale-transition"
              offset-y
              :nudge-right="40"
              :close-on-content-click="false"
              v-model="picker">
              <template v-slot:activator="{ on }">
                <v-text-field
                  dense
                  outlined
                  readonly
                  :color="style.primary"
                  prepend-inner-icon="mdi-calendar-month"
                  :label="`Tanggal ${detail.title}`"
                  v-model="form.date"
                  v-on="on">
                </v-text-field>
              </template>
              <v-date-picker 
                :color="style.primary"
                v-model="form.date"
                @input="picker = false">
              </v-date-picker>
            </v-menu>
            <quill-editor 
              ref="myTextEditor"
              :options="option"
              v-model="form.desc">
            </quill-editor>
          </ValidationObserver>
        </v-card-text>
        <v-divider class="mx-4 my-2"/>
        <v-card-actions class="pa-5">
          <v-spacer/>
          <v-btn
            outlined
            :color="style.primary"
            class="text-capitalize green--text mx-1"
            :disabled="process.form"
            :loading="process.form"
            @click="save">
            <v-icon small class="mr-1">mdi-check</v-icon>
            Simpan
          </v-btn>
          <v-btn
            outlined
            color="red"
            class="text-capitalize red--text mx-1"
            :disabled="process.form"
            @click="dialog.status = false; selected = 0; detail = {}">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Tutup
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.images" 
      persistent
      width="1000">
      <v-card class="border-radius box-shadow"
        v-if="Object.keys(detail).length > 0">
        <v-img
          :src="detail.mortage_file"
          gradient="to top right, rgba(0, 0, 0, .5), rgba(0, 0, 0, .5)">
          <v-icon color="white" style="position: absolute; top: 15px; right: 15px;" 
            @click="dialog.images = false; detail = {}">
            mdi-close-circle-outline
          </v-icon>
        </v-img>
      </v-card>
    </v-dialog>
    
    <v-row>
      <v-col cols="12" class="py-0">
        <v-card
          style="border-radius: 0px;"
          flat>
          <div style="background: var(--color-primary)">
            <v-card-title class="subtitle-2 white--text">
              Pemberkasan Dokumen
            </v-card-title>
            <v-card-subtitle class="white--text line-text-first pt-2 caption">
              Anda bisa menambahkan dokumen lampiran.
            </v-card-subtitle>
          </div>
          <div v-for="(item, index) in step"
            :key="index">
            <v-card-text class="d-flex align-center">
              <span class="font-weight-bold">
                <v-icon :color="item.selected ? 'teal' : '#e0e0e0'" class="mr-1">mdi-check-circle</v-icon>
                {{ item.title }}
              </span>
              <v-spacer/>

              <!-- JIKA MASIH AKTIF -->
              <div v-if="booking.company_project_is_active === '1'">
                <v-btn
                  small
                  width="175"
                  color="teal"
                  class="text-capitalize white--text"
                  v-if="item.date.length < 1 && (user.user_company_roles_name.includes('superuser') || user.user_company_roles_name.includes('administrator'))"
                  :disabled="!item.editable"
                  @click="
                    dialog.status = true; 
                    selected = item.step; 
                    detail = item; 
                    form.nominal = booking.transaction_additional_transaction_data.price_kpr;
                    form.date = item.date; 
                    form.desc = item.note;">
                  <v-icon small class="mr-1">mdi-check</v-icon>
                  Tandai Sudah Selesai
                </v-btn>
              </div>
              <!-- JIKA SUDAH HABIS MASA AKTIF -->
              <div v-if="booking.company_project_is_active === '0'">
                <span class="red--text font-weight-bold">
                  Langganan Habis
                </span>
              </div>

              <div class="d-flex align-center" style="height: 28px;" v-if="item.date.length > 0">
                <!-- JIKA MASIH AKTIF -->
                <div class="d-flex align-center" v-if="booking.company_project_is_active === '1'">
                  <v-list-item class="py-0">
                    <v-list-item-content class="text-right py-0">
                      <v-list-item-title class="caption font-weight-bold teal--text mb-1">
                        Selesai
                      </v-list-item-title>
                      <v-list-item-subtitle class="text-third" style="font-size: 10px;">
                        Pada {{ item.date | date }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-btn
                    v-if="index !== 0 && (user.user_company_roles_name.includes('superuser') || user.user_company_roles_name.includes('administrator'))"
                    small
                    outlined
                    color="orange"
                    class="text-capitalize white--text"
                    @click="
                      dialog.status = true; 
                      selected = item.step; 
                      detail = item; 
                      form.nominal = booking.transaction_additional_transaction_data.price_kpr; 
                      form.date = item.date; 
                      form.desc = item.note;">
                    <v-icon small class="mr-1">mdi-pencil-outline</v-icon>
                    Ubah
                  </v-btn>
                </div>
                <!-- JIKA SUDAH HABIS MASA AKTIF -->
                <div v-if="booking.company_project_is_active === '0'">
                  <span class="red--text font-weight-bold">
                    Langganan Habis
                  </span>
                </div>
              </div>
            </v-card-text>
            <v-alert type="error" text dense prominent class="mx-4"
              v-show="error.message.length > 0"
              v-html="error.message">
            </v-alert>
            <!-- DOCUMENT -->
            <v-card-text class="pl-12 py-0" 
              v-if="(booking.transaction_payment_type === 'KPR' && index === 1) || (booking.transaction_payment_type === 'Cash' && index === 0)">
              <v-divider class="mb-2"/>
              <p class="caption mb-1">
                Dokumen Lampiran
              </p>
              <p class="text-third mb-0 caption">
                Beri tanda centang pada list jika dokumen lampiran telah tersedia
              </p>
            </v-card-text>
            <!-- DATA DOCUMENT -->
            <v-card-text class="pl-11 py-0" 
              v-if="(booking.transaction_payment_type === 'KPR' && index === 1) || (booking.transaction_payment_type === 'Cash' && index === 0)">
              <div>
              <!-- <div :style="form.document.length > 9 ? 'height: 290px; overflow-y: scroll;' : ''"> -->
                <v-row
                  v-for="(item, index) in form.document"
                  :key="index">
                  <v-col cols="8" class="py-0">
                    <v-card-text
                      class="mt-2 py-0 px-1 text-second d-flex align-center caption"
                      :class="!item.mortage_status ? 'text-second' : 'teal--text'">
                      <v-icon small class="mr-1" 
                        :color="!item.mortage_status ? '#7B7B7B' : 'teal'">
                        {{ !item.mortage_status ? 'mdi-file-upload-outline' : 'mdi-file-check-outline' }}
                      </v-icon>
                      {{ item.mortage_description }}
                    </v-card-text>
                  </v-col>
                  <v-col cols="4" class="text-right px-1 py-0">
                    <div
                      style="margin-top: 9.5px;"
                      v-if="!item.mortage_status">
                      <image-input class="ma-2" v-model="images[index]">
                        <div slot="activator">
                          <v-btn v-if="user.user_company_roles_name.includes('superuser') || user.user_company_roles_name.includes('administrator')"
                            elevation="3"
                            x-small
                            width="75"
                            :color="style.primary"
                            class="text-capitalize white--text">
                            <v-icon x-small class="mr-1">mdi-upload</v-icon>
                            Upload
                          </v-btn>
                        </div>
                      </image-input>
                    </div>
                    <div
                      style="margin-top: 9.5px;"
                      v-else>
                      <v-btn
                        elevation="3"
                        x-small
                        width="75"
                        color="blue"
                        class="text-capitalize white--text mx-2 mb-2"
                        @click="download_images(item)">
                        <v-icon x-small class="mr-1">mdi-download</v-icon>
                        Download
                      </v-btn>
                      <v-btn
                        elevation="3"
                        x-small
                        width="75"
                        color="orange"
                        class="text-capitalize white--text mx-2 mb-2"
                        @click="dialog.images = true; detail = item">
                        <v-icon x-small class="mr-1">mdi-arrow-expand-all</v-icon>
                        Lihat
                      </v-btn>
                    </div>
                    <!-- <div
                      style="margin-top: 9.5px;">
                      <image-input class="ma-2" v-model="images[index]">
                        <div slot="activator">
                          <v-btn
                            x-small
                            width="75"
                            :color="!item.mortage_status ? '#4FC3F7' : 'orange'"
                            class="text-capitalize white--text">
                            <v-icon x-small class="mr-1">
                              {{ !item.mortage_status ? 'mdi-upload' : 'mdi-arrow-expand-all' }}
                            </v-icon>
                            {{ !item.mortage_status ? 'Upload' : 'Lihat' }}
                          </v-btn>
                        </div>
                      </image-input>
                    </div> -->
                  </v-col>
                </v-row>
                <p class="caption text-second mt-3 mb-1 ml-1">
                  <span>
                    Tanggal {{ item.date | date }}
                  </span>
                </p>
                <p class="text-third ml-1 caption">
                  *Catatan: <span v-if="item.note === ''">-</span>
                  <span v-else v-html="item.note"></span>
                </p>
                <v-divider class="my-5 mb-0"/>
              <!-- </div> -->
              </div>
            </v-card-text>
            <v-card-text class="py-0" v-if="(index === 0 || (index > 1 && index < 4)) && item.selected && Object.keys(booking).length > 0">
              <p class="caption text-second mt-3 mb-1 ml-8" v-if="booking.transaction_payment_type === 'KPR' && index === 0">
                Nominal KPR sebesar <b>{{ parseInt(booking.transaction_additional_transaction_data.price_kpr) | price }}</b>
              </p>
              <p class="caption text-second mt-3 mb-1 ml-8">
                <span>
                  Tanggal {{ item.date | date }}
                </span>
              </p>
              <p class="text-third ml-8 caption">
                *Catatan: <span v-if="item.note === ''">-</span>
                <span v-else v-html="item.note"></span>
              </p>
              <v-divider class="ml-8"/>
            </v-card-text>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "../../service/Axios";
  import ImageInput from "@/components/ImageInput.vue";
  import moment from 'moment';
  export default {
    data () {
      return {
        option: {
          modules: {
            toolbar: [
              ['bold', 'italic', 'underline'],
              [{ 'list': 'ordered'}, { 'list': 'bullet' }],
              [{ 'size': ['small', false, 'large', 'huge'] }],
              [{ 'color': [] }, { 'background': [] }],
              [{ 'align': [] }]
            ]
          },
          placeholder: 'Keterangan'
        },
        dialog: {
          status: false,
          images: false
        },
        selected: 0,
        step: [],
        document: [],
        detail: {},
        images: [],
        picker: false,
        form: {
          transaction_id: '',
          document: [],
          date: moment().format('Y-MM-DD'),
          nominal: 0,
          desc: ''
        },
        process: {
          run: false,
          form: false
        },
        error: {
          message: ''
        },
        style: {
          primary: "#8BC541"
        }
      }
    },
    computed: {
      user () {
        return this.$store.state.user
      }
    },
    components: {
      ImageInput
    },
    props: [
      'booking'
    ],
    watch: {
      images: {
        handler: function (val) {
          let t = this
          val.forEach(function(item, index) {
            console.log(item.url)
            console.log(index)
            if (item.url) {
              t.form.document[index].mortage_file = item.url
              t.form.document[index].mortage_status = true
            }
          })
        },
        deep: true
      }
    },
    mounted () {
      this.fetch()
    },
    methods: {
      async fetch() {
        await get(`auth/transaction/mortage-document/detail`, {
          params: {
            transaction_id: this.$route.query.transaction
          }
        })
        .then((response) => {
          let res = response.data
          if (res.status === 200) {
            let pengajuan = res.data.results.informasi_pengajuan

            get(`auth/company/project/detail-unit-transaction`, {
              params: {
                unit_id: this.$route.query.unit
              }
            })
            .then(response => {
              let res = response.data
              if (res.status == 200) {
                console.log(res.data.transaction_payment_type)
                if (res.data.transaction_payment_type === 'KPR') {
                  this.step = pengajuan
                } else {
                  this.step = [pengajuan[1], pengajuan[4]]
                }

                this.reset(res.data.transaction_payment_type === 'KPR' ? 1 : 0)
              }
            })
            // this.step = res.data.results.informasi_pengajuan
            // this.reset()
          }
        })
      },
      async fetchDocument() {
        this.process.run = true
        await get(`auth/mortage-document-company/detail`)
        .then((response) => {
          let res = response.data
          if (res.status === 200) {
            this.process.run = false
            if (this.form.document.length < 1) {
              let doc = res.data.ref_mortage_mortage_id
              for(let i = 0; i < doc.length; i++) {
                console.log(doc.length)
                this.form.document.push({
                  mortage_id: doc[i].mortage_id,
                  mortage_description: doc[i].mortage_description,
                  mortage_file: '',
                  mortage_status: false
                })
              }
            }
          }
        })
      },
      reset(index) {
        this.form.transaction_id = this.$route.query.transaction

        let doc = this.step[index].document
        if (doc.length > 0) {
          this.form.document = doc
        } else {
          this.fetchDocument()
        }
      },
      save() {
        this.error.message = ''

        if (this.selected === 2) {
          this.documents()
        } else {
          this.statuses()
        }
      },
      async documents() {
        this.process.form = true
        
        let forms = Object.assign({}, this.form)
        forms.document = JSON.stringify(forms.document)
        
        await post(`auth/transaction/mortage-document/create`, {
          data: forms
        }).then(response => {
          let res = response.data
          if (res.status === 200) {
            this.process.form = false
            this.dialog.status = false
            this.selected = 0
            this.fetch()
          } else {
            this.process.form = false
            this.error.message = res.msg
          }
        })
      },
      async statuses() {
        this.error.message = ''
        const isValid = await this.$refs.observer.validate()
        if (isValid) {
          this.process.form = true
          await post(`auth/transaction/mortage-document/update-status`, {
            data: {
              transaction_id: this.form.transaction_id,
              status: this.detail.title,
              date: this.form.date,
              nominal: this.form.nominal,
              desc: this.form.desc
            }
          }).then(response => {
            let res = response.data
            if (res.status === 200) {
              if (this.detail.title === 'SP3K') {
                window.location.reload()
              } else {
                this.process.form = false
                this.dialog.status = false
                this.selected = 0
                this.fetch()
              }
            } else {
              this.process.form = false
              this.error.message = res.msg
            }
          })
        }
      },
      download_images(item) {
        //console.log(item)
        /*
        get(item.mortage_file, { 
          responseType: 'blob',
          headers: {
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
            'Access-Control-Allow-Headers': "append,delete,entries,foreach,get,has,keys,set,values,Authorization",
            'key': '59e51e5db668184d8c4a085fb8389c3acfd76a50'
          }, 
        }).then(response => {
          const blob = new Blob([response.data], { type: 'application/image' })
          const link = document.createElement('a')
          link.href = URL.createObjectURL(blob)
          link.download = label
          link.click()
          URL.revokeObjectURL(link.href)
        }).catch(console.error)
        */
        window.open(item.mortage_file, '_blank', 'download');
      }
    }
  }
</script>